import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "../admin/layout/AdminLayout";

import { AuthProvider }  from './context/AuthContext';
import PublicRoute from "./utils/PublicRoute";
import PrivateRoute from "./utils/PrivateRoute";
import Login from "./screens/login";

import Dashboard from "./screens/dashboard";

import AddEditUser from "./screens/users/add_user";
import AllUser from "./screens/users/all_user";

import AddEditHotel from "./screens/hotel/add_edit";
import AllHotel from "./screens/hotel/main";

import AddEditHotelTable from "./screens/hotel_table/add_edit";
import AllHotelTable from "./screens/hotel_table/main";

import AddEditCategory from "./screens/category/add_edit";
import AllCategory from "./screens/category/main";

import AddEditProduct from "./screens/product/add_edit";
import AllProduct from "./screens/product/main";

import AddEditMenu from "./screens/menu/add_edit";
import AllMenu from "./screens/menu/main";

import ChangePassword from "./screens/changePassword";

import ErrorPage from '../common/error/Component';
import "./css/style.css";



const AdminRoute = () => {
  return (
    <AuthProvider>
        <Routes>

            <Route path="login" element={<PublicRoute><Login /></PublicRoute>} />
            
            <Route element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
                <Route path="dashboard" element={<Dashboard />} />

                <Route path="user" element={<AllUser />} />
                <Route path="add-user" element={<AddEditUser />} />
                <Route path="edit-user/:id" element={<AddEditUser />} />

                <Route path="hotel" element={<AllHotel />} />
                <Route path="add-hotel" element={<AddEditHotel />} />
                <Route path="edit-hotel/:id" element={<AddEditHotel />} />

                <Route path="/:hotelId/tables" element={<AllHotelTable />} />
                <Route path="/:hotelId/tables/:id" element={<AddEditHotelTable />} />

                <Route path="category" element={<AllCategory />} />
                <Route path="add-category" element={<AddEditCategory />} />
                <Route path="edit-category/:id" element={<AddEditCategory />} />

                <Route path="product" element={<AllProduct />} />
                <Route path="add-product" element={<AddEditProduct />} />
                <Route path="edit-product/:id" element={<AddEditProduct />} />

                <Route path="menu" element={<AllMenu />} />
                <Route path="add-menu" element={<AddEditMenu />} />
                <Route path="edit-menu/:id" element={<AddEditMenu />} />

                <Route path="changePassword" element={<ChangePassword />} />
            </Route>

            <Route path="*" element={<ErrorPage/>} />

        </Routes>
    </AuthProvider>
  );
};

export default AdminRoute;
